import { type Registry as Services, service } from '@ember/service';
import Model, { attr, belongsTo } from '@ember-data/model';
import { Type } from '@warp-drive/core-types/symbols';
import type { TotalRevenueSegmentationBreakdownSummaryItem } from 'lumen/models';
import type { HoteldateTransformReturn } from 'lumen/transforms/hoteldate';

export default class TotalRevenueSegmentationBreakdownSummaryReference extends Model {
  [Type] = 'total-revenue/segmentation-breakdown/summary-reference' as const;

  @belongsTo('total-revenue/segmentation-breakdown/summary-item', {
    async: false,
    inverse: 'referenceValues',
  })
  declare totalRevenueItem: TotalRevenueSegmentationBreakdownSummaryItem;

  @attr('number') declare matchedNonRoomRevenue: number;
  @attr('hoteldate')
  declare referenceFromDate: NonNullable<HoteldateTransformReturn>;
  @attr declare referenceType: string;
  @attr('number') declare unmatchedNonRoomRevenue: number;

  @service declare totalRevenue: Services['total-revenue'];

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  get formattedMatchedNonRoomRevenueRelativeChange() {
    return this.totalRevenue.formatRelativeChange(
      this.matchedNonRoomRevenueRelativeChange,
    );
  }

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  get formattedUnmatchedNonRoomRevenueRelativeChange() {
    return this.totalRevenue.formatRelativeChange(
      this.unmatchedNonRoomRevenueRelativeChange,
    );
  }

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  get matchedNonRoomRevenueRelativeChange() {
    return this.totalRevenue.calculateRelativeChange(
      this.totalRevenueItem.matchedNonRoomRevenue,
      this.matchedNonRoomRevenue,
    );
  }

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  get translatedReferenceType() {
    return this.totalRevenue.translateReferenceType(this.referenceType);
  }

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  get unmatchedNonRoomRevenueRelativeChange() {
    return this.totalRevenue.calculateRelativeChange(
      this.totalRevenueItem.unmatchedNonRoomRevenue,
      this.unmatchedNonRoomRevenue,
    );
  }
}
